import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "counter-card" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "material-symbols-outlined" }
const _hoisted_4 = { class: "counter-card__value" }

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CounterCard',
  props: {
    title: {},
    value: {},
    icon: {},
    actionDisabled: { type: Boolean }
  },
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const titleClass = computed(() => (props.icon ? 'counter-card__title' : 'counter-card__title counter-card__title-wide'));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: _normalizeClass(titleClass.value)
    }, _toDisplayString(__props.title), 3),
    (__props.icon)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "counter-card__refresh",
          disabled: __props.actionDisabled,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('expand')))
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(__props.icon), 1)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_4, _toDisplayString(__props.value), 1)
  ]))
}
}

})